import React, { useEffect, useMemo, useState } from "react";
import "./BlogPosts.css";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { blogPosts } from "../../../../data/blogPosts";
import { useTranslation } from "react-i18next";
import { getBlogPosts } from "../../../../api/blog";
import { resolveMediaUrl } from "../../../../utils/media";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const BlogPosts = () => {
  const { t, i18n } = useTranslation();
  const [posts, setPosts] = useState(blogPosts.slice(0, 3));

  useEffect(() => {
    let isMounted = true;
    const loadPosts = async () => {
      try {
        const data = await getBlogPosts({ language: (i18n.language || "en").toLowerCase() });
        const list = Array.isArray(data) ? data : [];
        const mapped = list
          .slice(0, 3)
          .map((post) => ({
            id: String(post.id),
            title: post.title || "",
            desc: post.text || "",
            date: formatDate(post.publishedAtUtc),
            image: resolveMediaUrl(post.imageUrl),
          }))
          .filter((post) => post.id && (post.title || post.desc || post.image));

        if (isMounted) {
          setPosts(mapped.length ? mapped : blogPosts.slice(0, 3));
        }
      } catch (_error) {
        if (isMounted) {
          setPosts(blogPosts.slice(0, 3));
        }
      }
    };

    loadPosts();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  const visiblePosts = useMemo(() => posts.slice(0, 3), [posts]);

  return (
    <section className="blog">
      <div className="blog-container">

        <span className="blog-tag tag">{t("sections.home.blogPosts.tag")}</span>

        <h2 className="blog-title">{t("sections.home.blogPosts.title")}</h2>

        <div className="blog-grid">
          {visiblePosts.map((post, index) => (
            <Link to={`/blog/${post.id}`} className="blog-card" key={post.id}>
              
              <div className="blog-img">
                <img src={post.image} alt={post.title} />
              </div>

              <div className="blog-content">
                <span className="blog-date">{post.date}</span>

                <h3>{post.title}</h3>

                <p>{post.desc}</p>

                <span className="blog-link">
                  {t("sections.home.blogPosts.readArticle")} <FaArrowRight />
                </span>
              </div>

              {index !== visiblePosts.length - 1 && <div className="divider" />}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPosts;